// The template of the import (platform П14): a file with the header of the fields a person may load. The person
// fills it and loads it back — the same names the section shows, so the columns are matched without guessing.

import { csvFile, type FieldDef, type Id } from '@confdeck/core-shared';

/**
 * The fields a file may carry: not archived, not the app's own (a managed field is changed by its actions) and
 * not hidden from the person.
 */
export function importableFields(fields: FieldDef[], hidden: Id[] = []): FieldDef[] {
  return fields.filter((f) => !f.archivedAt && !f.options.managed && !hidden.includes(f.id));
}

/** An empty file with the header of the fields: the names of the section, separated by a semicolon. */
export function templateCsv(fields: FieldDef[]): string {
  return csvFile([fields.map((f) => f.name)]);
}

/** The name of the file with the template. */
export function templateName(typeName: string): string {
  return `Шаблон ${typeName}.csv`;
}
